import { BREAKPOINTS } from '@skyscanner-internal/backpack-web/bpk-component-breakpoint';
import BpkMobileScrollContainer from '@skyscanner-internal/backpack-web/bpk-component-mobile-scroll-container';
import { cssModules } from '@skyscanner-internal/backpack-web/bpk-react-utils';
import { useBreakpoint, useTranslations } from '@web-platform/shared-travel-tools-utils-frontend';
import { useSummary } from '@web-platform/travel-tools-flight-price-map-data-access-frontend';
import { StatCard } from '@web-platform/travel-tools-flight-price-map-ui';

import STYLES from './StatSummary.module.scss';

const cls = cssModules(STYLES);

export const StatSummary = () => {
  const summary = useSummary();
  const { translate } = useTranslations();
  const isMobile = useBreakpoint(BREAKPOINTS.MOBILE);

  const cards = (
    <>
      {summary?.cheaperCount != null && (
        <StatCard
          value={summary.cheaperCount}
          label={translate('travel_confidence_map_stat_cheaper_label')}
          status="low"
        />
      )}
      {summary?.asExpectedCount != null && (
        <StatCard
          value={summary.asExpectedCount}
          label={translate('travel_confidence_map_stat_expected_label')}
          status="expected"
        />
      )}
    </>
  );

  if (isMobile) {
    return (
      <div className={cls('container')}>
        <BpkMobileScrollContainer>
          <div className={cls('scrollInner')}>{cards}</div>
        </BpkMobileScrollContainer>
      </div>
    );
  }

  return (
    <div className={cls('container')}>
      <div className={cls('desktopInner')}>{cards}</div>
    </div>
  );
};
